import BaseModel from '../core/BaseModel'
import KindTypeModel from './KindTypeModel'
export default class ExchangeModel extends BaseModel {
    constructor() {
        super({ 
                name: "exchange",
                tableName: 'record', 
                label: "Danh sách Chuyển hộp",
            },  
            {
                stt: { 
                    name: "stt",
                    label: "STT",
                    width : 5,
                    class: 'center',
                    computed: (data, index) => {
                        data.stt = index + 1;
                    }
                },
                id: { 
                    name: 'id', 
                    type: "Uuid", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                code : { 
                    name: 'code',
                    type: "String",
                    class: "center", 
                    label: 'Mã phiếu chuyển',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    }
                },
                farm: {
                    refs: "farm {id name}",
                    display: false
                },
                farm_name: {
                    name: 'farm_name', 
                    type: "String", 
                    class: "center", 
                    label: 'Trang trại',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.farm_name = "";
                    }
                },
                type: {
                    name: 'type', 
                    type: "Selection", 
                    label: 'Thể loại nhập',
                    options: [
                        {
                            label: "Nhập cua",
                            value: 1
                        },
                        {
                            label: "Chuyển hộp",
                            value: 3
                        }
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    display: false
                },
                kind: {
                    refs: "kind {id name weight type{id name}}",
                    display: false
                },
                record_details: {
                    refs: "record_details {number type obj_box{ unit {code} code}}",
                    display: false
                },
                userCreateBy: {
                    refs: "userCreateBy {id fullname}",
                    display: false
                },
                kind_type: {
                    name: 'kind_type', 
                    type: "Selection",
                    class: "center", 
                    custom: "SelectionText", 
                    label: 'Chủng loại',
                    models: new KindTypeModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    computed: (data) => {
                        data.kind_type = "";
                    }
                },
                kind_name: {
                    name: 'kind_name', 
                    type: "String", 
                    class: "center", 
                    label: 'Tên loại',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.kind_name = "";
                    }
                },
                history_move_box: {
                    refs: "history_move_box {id obj_box{ unit {code} code}}",
                    display: false
                },
                number_movebox: {
                    name: 'number_movebox', 
                    type: "Number", 
                    label: 'SL cua chuyển',
                    class: "center", 
                },
                area_exchange: {
                    name: 'area_exchange', 
                    type: "CustomUrl", 
                    class: "center", 
                    label: 'Khu vực chuyển',
                    computed: (data) => {
                        data.area_exchange = "";
                    }
                },
                area_to: {
                    name: 'area_to', 
                    type: "CustomUrl", 
                    label: 'Khu vực đến',
                    class: 'center',
                    computed: (data) => {
                        data.area_to = "";
                    }
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    class: "center", 
                    label: 'Ngày chuyển',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },
            },
        )
    }

}